const TAMANHO_ORDEM = ["SOLTEIRO", "CASAL", "QUEEN", "KING", "SUPER KING"];

function gradeCellKey(linha, tamanho) {
  return `${linha}|||${tamanho}`;
}

/** Linha do produto (cor/padrão da grade, ex. "Báltico/Azul", "Coralina" — WS_PRODUTO_GRADE_LINHA via linhaGrade). */
function readLinha(product) {
  const value = String(product?.linhaGrade || product?.linhaLabel || "").trim();
  return value || "Sem linha";
}

function readTamanho(product) {
  const coluna = String(product?.colunaGrade || "").trim().toUpperCase();
  const COLUNA_TAMANHO = {
    K: "KING",
    Q: "QUEEN",
    C: "CASAL",
    S: "SOLTEIRO",
    SK: "SUPER KING",
  };
  if (coluna && coluna.length <= 2 && COLUNA_TAMANHO[coluna]) {
    return COLUNA_TAMANHO[coluna];
  }
  return String(
    product?.tamanhoGrade || product?.tamanhoLabel || product?.tamanho || "",
  ).trim();
}

function sortTamanhos(list) {
  return [...list].sort((a, b) => {
    const ia = TAMANHO_ORDEM.indexOf(String(a).toUpperCase());
    const ib = TAMANHO_ORDEM.indexOf(String(b).toUpperCase());
    if (ia >= 0 && ib >= 0) return ia - ib;
    if (ia >= 0) return -1;
    if (ib >= 0) return 1;
    return String(a).localeCompare(String(b), "pt-BR");
  });
}

/**
 * Grade de um card = Linha (cor/padrão) x Tamanho. A cor deixou de ser uma dimensão
 * separada da grade: o card já é específico de uma cor (o nome comercial já vem
 * completo, ex. "Bossa Grafite"), então cada Linha é uma linha só, sem sub-nível.
 */
function computeGradeFromProducts(products) {
  const cells = {};
  const linhas = new Set();
  const sizes = new Set();

  (products || []).forEach((product) => {
    const linha = readLinha(product);
    const tamanho = readTamanho(product);
    if (!tamanho) return;

    product.linhaLabel = linha;
    product.tamanhoLabel = tamanho;

    const key = gradeCellKey(linha, tamanho);
    if (!cells[key]) cells[key] = product;

    sizes.add(tamanho);
    linhas.add(linha);
  });

  const groups = [...linhas]
    .sort((a, b) => a.localeCompare(b, "pt-BR"))
    .map((linha) => ({ linha }));

  return {
    sizes: sortTamanhos([...sizes]),
    groups,
    cells,
  };
}

export function buildFamilyGrade(fam) {
  fam.grade = computeGradeFromProducts(fam?.products);
}

/**
 * Recalcula a grade a partir de um subconjunto de produtos (ex.: só os de uma vitrine
 * específica), sem mutar `fam` — usado pelo filtro de Vitrine da sidebar, pra não
 * misturar tamanhos/agrupadores de vitrines diferentes quando a mesma grade comercial
 * existe em mais de uma vitrine que a loja enxerga (mesmo card, produtos de origens
 * diferentes).
 */
export function buildFamilyGradeScoped(products) {
  return computeGradeFromProducts(products);
}

export function getGradeCell(fam, linha, tamanho) {
  return fam?.grade?.cells?.[gradeCellKey(linha, tamanho)] ?? null;
}

export function listGradeAgrupadores(fam) {
  return (fam?.grade?.groups || [])
    .map((group) => group.linha)
    .filter((linha) => linha && linha !== "Sem linha");
}

export function listGradeSizes(fam) {
  return fam?.grade?.sizes || [];
}
